import React from "react";
import "./About.css";
import {
  FaGem,
  FaLeaf,
  FaHeart,
  FaStar,
  FaGlobe,
  FaAward,
  FaMagic,
  // FaCar,
} from "react-icons/fa";

function About() {
  const values = [
    { icon: <FaGem />, title: "Premium Quality" },
    { icon: <FaHeart />, title: "Positivity" },
    { icon: <FaStar />, title: "Elegance" },
    { icon: <FaLeaf />, title: "Freshness" },
    { icon: <FaMagic />, title: "Innovation" },
    { icon: <FaAward />, title: "Authenticity" },
    { icon: <FaGlobe />, title: "Sustainability" },
    { icon: <FaGem />, title: "Everyday Luxury" },
  ];

  const personality = [
    "Modern",
    "Elegant",
    "Minimalist",
    "Premium",
    "Confident",
    "Unisex",
    "Fresh",
    "Emotional",
  ];

  return (
    <>
      {/* Hero */}
      <section className="about-hero">
        <img src="/about-banner.jpg" alt="" />

        <div className="about-overlay"></div>

        <div className="about-hero-content">
          <h5>ABOUT SAH?</h5>

          <h1>Every Mood Has a Scent.</h1>

          <p>
            Premium fragrances designed to reflect your emotions, personality,
            and every unforgettable journey.
          </p>
        </div>
      </section>

      {/* Brand Story */}
      <section className="brand-story">
        <div className="container">

          <div className="story-image">
            <img src="/logo.png" alt="" />
          </div>

          <div className="story-content">
            <span>OUR STORY</span>

            <h2>Brand Story</h2>

            <p>
              At SAH?, we believe that Scents is more than a fragrance — it's a
              reflection of how you feel. Every journey, every moment, and every
              emotion deserves a fragrance that complements it.
            </p>

            <p>
              Whether you're starting a new day, chasing your dreams, finding
              peace, or celebrating life's victories, SAH? creates scents that
              enhance your mood and leave a lasting impression.
            </p>

            <p>
              Designed for every personality and every destination, our premium
              fragrances bring freshness, confidence, and comfort wherever life
              takes you.
            </p>

            <h4>Every Mood Has a Scent. Discover Yours.</h4>
          </div>

        </div>
      </section>

      {/* Description */}

      <section className="about-description">
        <div className="container-small">

          <h2>Short Description</h2>

          <p>
            SAH? is a premium Scents brand dedicated to creating high-quality
            scents for every mood and every journey. From car air fresheners to
            home fragrances and lifestyle products, every fragrance is crafted
            to inspire confidence, comfort, and unforgettable moments.
          </p>

        </div>
      </section>

      {/* Mission Vision */}

      <section className="mission-section">

        <div className="container mission-grid">

          <div className="mission-card">
            <h3>Mission</h3>

            <p>
              To create fragrances that inspire positive emotions, elevate
              everyday experiences, and make every journey more enjoyable.
            </p>
          </div>

          <div className="mission-card">
            <h3>Vision</h3>

            <p>
              To become a globally recognized fragrance brand that connects
              people with scents that reflect their emotions, personalities,
              and lifestyles.
            </p>
          </div>

        </div>

      </section>

      {/* Values */}

      <section className="values-section">

        <div className="container">

          <div className="section-title">
            <span>OUR VALUES</span>

            <h2>Brand Values</h2>
          </div>

          <div className="values-grid">

            {values.map((item, index) => (

              <div className="value-card" key={index}>
                <div className="value-icon">{item.icon}</div>

                <h4>{item.title}</h4>
              </div>

            ))}

          </div>

        </div>

      </section>

      {/* Personality */}

      <section className="personality-section">

        <div className="container-small">

          <div className="section-title">
            <span>OUR PERSONALITY</span>

            <h2>Brand Personality</h2>
          </div>

          <div className="personality-tags">

            {personality.map((item, index) => (
              <span key={index}>{item}</span>
            ))}

          </div>

        </div>

      </section>

      {/* Philosophy */}

      <section className="philosophy-section">

        <div className="container-small">

          <h2>
            “Every emotion tells a story. Every story deserves a scent.”
          </h2>

          <p>
            At SAH?, we believe Scents has the power to transform ordinary
            moments into meaningful memories. Whether you're driving to work,
            heading on a road trip, relaxing at home, or celebrating life's
            milestones, there's a SAH fragrance that fits the moment.
          </p>

        </div>

      </section>

      {/* Category */}

      <section className="category-section">

        <div className="container category-grid">

          <div className="category-content">

            <span>PRODUCT CATEGORY</span>

            <h2>Scented Pouches</h2>

            <p>
             Premium fragrances for your car, closet, drawers, gym bag, and any space that needs a mood boost.
            </p>

          </div>

          <div className="category-image">
            <img src="/logo.png" alt="" />
          </div>

        </div>

      </section>

      {/* CTA */}

      <section className="about-cta">

        <h2>Find Your Scent. Feel Your Mood.</h2>

        <p>
          Discover premium fragrances designed for every journey.
        </p>

        <button>SHOP NOW</button>

      </section>
    </>
  );
}

export default About;